import Vue from "vue/dist/vue.esm";

export default function init() {
  const element = document.getElementById("socialSharing");

  if (element) {
    Vue.config.productionTip = false;

    new Vue({
      el: "#socialSharing",
      methods: {
        addCover(e) {
          e.currentTarget.classList.add("noHover");
        },
        removeCover(e) {
          e.currentTarget.classList.remove("noHover");
        }
      }
    });
  }
}
